/**
 * The valley's factions. Every character has a standing with each, from -1000 to 1000;
 * quests, contracts, trade and fighting their people move it. Standing decides who will
 * trade with you, which quests open, and who attacks you on sight in their territory.
 */
export type FactionId = 'settlers' | 'drift' | 'reavers' | 'kept';
export const FACTION_IDS: FactionId[] = ['settlers', 'drift', 'reavers', 'kept'];

export interface FactionDef {
  name: string;
  /** Standing every new character starts with. */
  start: number;
  /** Where they are, in a few words. */
  where: string;
  blurb: string;
  /** Helping this faction costs you a little with these. */
  rivals: FactionId[];
}

export const FACTIONS: Record<FactionId, FactionDef> = {
  settlers: { name: 'Meadowfold Settlers', start: 200, where: 'Meadowfold and the farms', blurb: 'The people rebuilding the valley, one fence at a time.', rivals: ['reavers'] },
  drift: { name: 'The Drift', start: 0, where: 'Caravans, the lake market, the shore', blurb: 'Scavenger traders. Everything has a price, and they know it.', rivals: [] },
  reavers: { name: 'Rustcliff Reavers', start: -600, where: 'The roads and the Rustcliff quarry', blurb: 'Raiders who take what they need, and most of what they want.', rivals: ['settlers'] },
  kept: { name: 'The Beacon Kept', start: -600, where: 'Ashen Ridge, around the old beacon', blurb: 'They tend the beacon and wait for an answer. Outsiders are not welcome.', rivals: [] },
};

export const STANDING_MIN = -1000, STANDING_MAX = 1000;
export type StandingBand = 'hostile' | 'wary' | 'neutral' | 'friendly' | 'trusted';
export const STANDING_BANDS: { band: StandingBand; name: string; from: number }[] = [
  { band: 'hostile', name: 'Hostile', from: STANDING_MIN },
  { band: 'wary', name: 'Wary', from: -500 },
  { band: 'neutral', name: 'Neutral', from: -100 },
  { band: 'friendly', name: 'Friendly', from: 100 },
  { band: 'trusted', name: 'Trusted', from: 500 },
];
export function standingBand(n: number): StandingBand {
  let b: StandingBand = 'hostile';
  for (const s of STANDING_BANDS) if (n >= s.from) b = s.band;
  return b;
}
export const isFactionId = (v: unknown): v is FactionId => typeof v === 'string' && v in FACTIONS;
/** A character's standing with a faction (defaults to where everyone starts). */
export const standingOf = (c: { standing?: Partial<Record<FactionId, number>> }, f: FactionId) => c.standing?.[f] ?? FACTIONS[f].start;
